import { render, staticRenderFns } from "./group_popper.vue?vue&type=template&id=5d01ce38&"
import script from "./group_popper.vue?vue&type=script&lang=js&"
export * from "./group_popper.vue?vue&type=script&lang=js&"
import style0 from "./group_popper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports